/* Rosebound book filter map. Each value: v = label, tr = curated custom.tropes values,
   tag = product tags, syn = search words that should point to this value.
   basic: true = shown in Basic mode. Groups with advanced: true only show in Advanced mode.
   The "leaveout" group removes books instead of keeping them. */
(function () {
  var G = [
    { key: 'genre', label: 'Genre', field: 'genre', values: [
      { v: 'Romantasy', genre: ['Romantasy'], syn: ['romantasy', 'fantasy romance'] },
      /* subset of Romantasy (same rule as the Dark Fantasy Romance collection: Romantasy + mood:dark) */
      { v: 'Dark Fantasy Romance', special: 'darkfantasy', syn: ['dark fantasy romance', 'dark fantasy', 'dark romantasy'] },
      { v: 'Paranormal Romance', genre: ['Paranormal Romance'], syn: ['paranormal romance', 'paranormal'] },
      { v: 'Contemporary Romance', genre: ['Contemporary Romance'], syn: ['contemporary romance', 'contemporary'] },
      { v: 'Dark Romance', genre: ['Dark Romance'], syn: ['dark romance'] },
      { v: 'Sports Romance', genre: ['Sports Romance'], syn: ['sports romance', 'sports'] },
      { v: 'Cowboy Romance', genre: ['Cowboy Romance'], syn: ['cowboy romance', 'cowboy', 'cowboys', 'western romance'] },
      { v: 'Historical Romance', genre: ['Historical Romance'], syn: ['historical romance', 'historical', 'regency', 'bridgerton'] },
      { v: 'LGBTQ+ Romance', genre: ['LGBTQ+ Romance'], syn: ['lgbtq', 'lgbtq+', 'lgbt', 'lgbt+', 'lgbt romance', 'lgbtq romance', 'queer romance', 'queer', 'lgbtq author', 'queer author', 'queer authors', 'lgbt author'] },
      { v: 'Young Adult', genre: ['Young Adult'], syn: ['young adult', 'ya'] },
      { v: "Children's", genre: ["Children's"], syn: ['kids', 'children', "children's", 'picture book'] },
      { v: 'Classics & Literary Fiction', genre: ['Classics & Literary Fiction'], syn: ['classics', 'classic', 'literary fiction'] }
    ]},
    { key: 'spice', label: 'Spice', field: 'spice', values: [
      { v: '0 – Clean', spice: ['0'], syn: ['clean romance', 'clean', 'closed door', 'no spice'] },
      { v: '1 – Sweet', spice: ['1'], syn: ['sweet romance', 'sweet', 'low spice'] },
      { v: '2 – Warm', spice: ['2'], syn: [] },
      { v: '3 – Spicy', spice: ['3'], syn: ['spicy'] , group: 'spicy' },
      { v: '4 – Very Spicy', spice: ['4'], syn: ['very spicy', 'smut', 'smutty'], group: 'spicy' },
      { v: '5 – Scorching', spice: ['5'], syn: ['scorching', 'extra spicy'] }
    ]},
    { key: 'tropes', label: 'Tropes', field: 'tropes', values: [
      /* Basic 12 = best-selling tropes (cover ~91% of book sales, Jun–Oct 2026), in sales order */
      { v: 'Slow Burn', tr: ['Slow Burn'], basic: true, syn: ['slow burn', 'slowburn'] },
      { v: 'Forced Proximity', tr: ['Forced Proximity', 'Only One Bed'], basic: true, syn: ['forced proximity', 'only one bed', 'one bed', 'snowed in', 'stuck together'] },
      { v: 'Enemies to Lovers', tr: ['Enemies to Lovers'], tag: ['trope:rivals-to-lovers'], basic: true, syn: ['enemies to lovers', 'enemy to lover', 'enemies 2 lovers', 'e2l', 'enemies', 'rivals to lovers', 'rivals'] },
      { v: 'Friends to Lovers', tr: ['Friends to Lovers'], basic: true, syn: ['friends to lovers', 'friend to lover', 'best friends to lovers', 'f2l'] },
      { v: 'Found Family', tr: ['Found Family'], basic: true, syn: ['found family'] },
      { v: 'Grumpy x Sunshine', tr: ['Grumpy x Sunshine'], basic: true, syn: ['grumpy sunshine', 'grumpy x sunshine', 'grumpy/sunshine', 'grumpy'] },
      { v: 'Forbidden Love', tr: ['Forbidden Love'], basic: true, syn: ['forbidden love', 'forbidden'] },
      { v: 'Second Chance', tr: ['Second Chance'], basic: true, syn: ['second chance', 'second chance romance', 'exes'] },
      { v: 'Fake Dating', tr: ['Fake Dating'], basic: true, syn: ['fake dating', 'fake relationship', 'fake date', 'fake boyfriend', 'fake girlfriend', 'fake engagement'] },
      { v: 'Fated Mates', tr: ['Fated Mates'], basic: true, syn: ['fated mates', 'fated mate', 'mates', 'soulmates', 'soul mates'] },
      { v: 'Age Gap', tr: ['Age Gap'], basic: true, syn: ['age gap', 'older man', 'age difference'] },
      { v: 'Marriage of Convenience', tr: ['Marriage of Convenience'], tag: ['trope:arranged-marriage'], basic: true, syn: ['marriage of convenience', 'arranged marriage', 'contract marriage'] },
      /* Advanced only */
      { v: 'Bodyguard', tag: ['trope:bodyguard'], syn: ['bodyguard', 'bodyguards'] },
      { v: 'Boss / Employee', tag: ['trope:boss-employee'], syn: ['boss employee', 'boss', 'office romance'] },
      { v: "Brother's Best Friend", tr: ["Brother's Best Friend"], tag: ['trope:siblings-best-friend', 'trope:brothers-best-friend'], syn: ["brother's best friend", 'brothers best friend', 'best friends brother', "best friend's brother", 'sibling best friend'] },
      { v: 'Captor / Captive', tag: ['trope:captor-captive'], syn: ['captor', 'captive', 'kidnapped', 'kidnapping'] },
      { v: 'Friends with Benefits', tag: ['trope:friends-with-benefits'], syn: ['friends with benefits', 'fwb'] },
      { v: 'He Falls First', tr: ['He Falls First'], syn: ['he falls first', 'falls first'] },
      { v: 'Insta-Love', tag: ['trope:insta-love'], syn: ['insta love', 'instalove', 'insta-love', 'love at first sight'] },
      { v: 'Love Triangle', tag: ['trope:love-triangle'], syn: ['love triangle'] },
      { v: 'Secret Relationship', tag: ['trope:secret-relationship'], syn: ['secret relationship', 'secret romance', 'sneaking around'] },
      { v: 'Single Parent', tag: ['trope:single-parent', 'trope:single-dad', 'trope:single-mom'], syn: ['single parent', 'single dad', 'single mom', 'single father', 'single mother'] },
      { v: 'Surprise Pregnancy', tag: ['trope:surprise-pregnancy', 'trope:secret-baby'], syn: ['surprise pregnancy', 'secret baby', 'pregnancy', 'accidental pregnancy'] },
      { v: 'Touch Her and Die', tr: ['Touch Her and Die'], tag: ['trope:touch-her-and-die'], syn: ['touch her and die', 'thad', 'protective hero'] },
      { v: 'Why Choose', tr: ['Why Choose'], tag: ['trope:reverse-harem', 'trope:menage'], syn: ['why choose', 'reverse harem', 'rh', 'poly romance', 'menage'] }
    ]},
    { key: 'characters', label: 'Characters & Creatures', field: 'characters', advanced: true, values: [
      { v: 'Fae', tr: ['Fae'], syn: ['fae', 'faerie', 'faeries', 'fairies', 'fey'] },
      { v: 'Vampires', tr: ['Vampires'], syn: ['vampire', 'vampires'] },
      { v: 'Werewolves & Shifters', tr: ['Werewolves & Shifters'], syn: ['werewolf', 'werewolves', 'shifter', 'shifters', 'wolf', 'wolves', 'lycan'] },
      { v: 'Witches', tr: ['Witches'], syn: ['witch', 'witches', 'witchy'] },
      { v: 'Dragons', tr: ['Dragons'], syn: ['dragon', 'dragons', 'dragon riders'] },
      { v: 'Monsters & Demons', tr: ['Monster Romance'], tag: ['trope:demons'], syn: ['monster romance', 'monster', 'monsters', 'demon', 'demons', 'orc', 'orcs'] },
      { v: 'Gods & Mythology', tag: ['trope:gods', 'trope:mythology'], syn: ['gods', 'mythology', 'greek mythology', 'myth', 'hades'] },
      { v: 'Royals', tag: ['trope:royalty'], syn: ['royal', 'royals', 'royalty', 'prince', 'princess'] },
      { v: 'Pirates', tag: ['trope:pirate'], syn: ['pirate', 'pirates'] },
      { v: 'Billionaire', tag: ['character:billionaire'], syn: ['billionaire', 'billionaires', 'rich hero'] },
      { v: 'Celebrity / Rockstar', tag: ['character:celebrity', 'character:actor', 'trope:rockstar'], syn: ['celebrity', 'rockstar', 'rock star', 'famous', 'actor', 'musician'] },
      { v: 'Bad Boy', tag: ['character:bad-boy'], syn: ['bad boy', 'bad boys'] },
      { v: 'Cinnamon Roll Hero', tag: ['character:cinnamon-roll'], syn: ['cinnamon roll', 'golden retriever', 'soft hero'] },
      { v: 'Morally Gray', tr: ['Morally Gray'], syn: ['morally gray', 'morally grey', 'villain', 'villains', 'antihero', 'anti hero'] },
      { v: 'Obsessed Hero', tr: ['Obsessed Hero'], syn: ['obsessed hero', 'obsessed', 'obsessive', 'possessive', 'possessive hero'] }
    ]},
    { key: 'setting', label: 'Setting & Story', field: 'setting', advanced: true, values: [
      { v: 'Small Town', tr: ['Small Town'], syn: ['small town', 'small-town'] },
      { v: 'Hockey', tr: ['Hockey'], syn: ['hockey', 'hockey romance'] },
      { v: 'Mafia', tr: ['Mafia'], syn: ['mafia', 'mob', 'mafia romance'] },
      { v: 'Motorcycle Club', tag: ['trope:motorcycle-club'], syn: ['motorcycle club', 'mc romance', 'biker', 'bikers'] },
      { v: 'Dark Academia', tr: ['Dark Academia'], syn: ['dark academia', 'academy', 'magic school'] },
      { v: 'College', tag: ['trope:college'], syn: ['college', 'university', 'campus'] },
      { v: 'Workplace', tag: ['trope:workplace'], syn: ['workplace', 'office', 'coworkers'] },
      { v: 'Military', tag: ['trope:military'], syn: ['military', 'soldier', 'navy seal', 'army'] },
      { v: 'Court Intrigue', tag: ['trope:court-intrigue', 'trope:political-intrigue'], syn: ['court intrigue', 'political intrigue', 'politics', 'scheming'] },
      { v: 'Romantic Suspense', tag: ['trope:romantic-suspense'], syn: ['romantic suspense', 'suspense', 'thriller'] },
      { v: 'Mystery', tag: ['trope:murder-mystery', 'trope:mystery', 'trope:amateur-sleuth'], syn: ['mystery', 'murder mystery', 'whodunit', 'cozy mystery'] },
      { v: 'Retellings & Fairytales', tag: ['trope:retelling', 'trope:fairytale'], syn: ['retelling', 'retellings', 'fairytale', 'fairy tale', 'fairytales', 'beauty and the beast'] },
      { v: 'Gothic', tag: ['trope:gothic'], syn: ['gothic', 'gothic romance'] },
      { v: 'Dystopian', tag: ['trope:dystopian'], syn: ['dystopian', 'dystopia'] },
      { v: 'Christmas', tag: ['holiday:christmas'], syn: ['christmas', 'holiday romance', 'holiday'] },
      { v: 'Halloween & Spooky', tag: ['holiday:halloween'], syn: ['halloween', 'spooky', 'spooky season', 'fall reads', 'autumn'] },
      { v: 'Summer Reads', tag: ['holiday:summer'], syn: ['summer', 'summer reads', 'beach read', 'beach reads'] }
    ]},
    /* BookTok filter removed (Jordan, Oct 12): not a mood; the Trending Now collection covers popularity */
    { key: 'mood', label: 'Mood', field: 'mood', advanced: true, values: [
      { v: 'Funny / Rom-Com', tr: ['Rom-Com'], tag: ['mood:funny'], syn: ['rom com', 'romcom', 'rom-com', 'funny', 'humor', 'laugh'] },
      { v: 'Cozy', tag: ['mood:cozy'], syn: ['cozy', 'cosy', 'comfort read', 'low angst'] },
      /* positive pick: only books we've confirmed have no third-act breakup (most books aren't checked yet) */
      { v: 'Confirmed: No Third-Act Breakup', tag: ['flag:no-3rd-act-breakup'], syn: ['no third act breakup', 'no 3rd act breakup', 'no third act', 'no 3rd act', 'no breakup'] },
      { v: 'Angsty', tag: ['mood:angsty'], syn: ['angsty', 'angst'] },
      { v: 'Emotional', tag: ['mood:emotional'], syn: ['emotional', 'tearjerker', 'make me cry'] },
      { v: 'Dark & Twisted', tag: ['mood:dark'], syn: ['dark', 'twisted', 'dark books'] }
    ]},
    { key: 'rep', label: 'Representation', field: 'representation', advanced: true, values: [
      { v: 'Black', tag: ['rep:black'], syn: ['black', 'black romance', 'black love', 'black fmc', 'black mc', 'african american'] },
      { v: 'Latine', tag: ['rep:latine'], syn: ['latine', 'latina', 'latino', 'latinx', 'hispanic'] },
      { v: 'Asian', tag: ['rep:asian'], syn: ['asian', 'aapi', 'asian american', 'korean', 'chinese', 'japanese'] },
      { v: 'South Asian', tag: ['rep:south-asian'], syn: ['south asian', 'indian', 'desi', 'pakistani'] },
      { v: 'Indigenous', tag: ['rep:indigenous'], syn: ['indigenous', 'native american'] },
      { v: 'Caribbean', tag: ['rep:caribbean'], syn: ['caribbean'] },
      { v: 'Jewish', tag: ['rep:jewish'], syn: ['jewish'] },
      { v: 'Muslim', tag: ['rep:muslim'], syn: ['muslim'] },
      { v: 'Multicultural', tag: ['rep:multicultural'], syn: ['multicultural', 'interracial', 'diverse', 'bipoc', 'poc'] },
      { v: 'Disability', tag: ['rep:disability'], syn: ['disability', 'disabled', 'disability rep', 'wheelchair', 'chronic illness', 'deaf'] },
      { v: 'Neurodivergent', tag: ['rep:neurodivergent'], syn: ['neurodivergent', 'adhd', 'autism', 'autistic', 'dyslexia'] },
      { v: 'Mental Health', tag: ['rep:mental-health'], syn: ['mental health', 'anxiety', 'depression'] },
      { v: 'Curvy / Plus-Size', tag: ['rep:curvy'], syn: ['curvy', 'plus size', 'plus-size', 'curvy fmc', 'curvy heroine', 'body positive'] },
      { v: 'Midlife / Over 40', tag: ['trope:midlife'], syn: ['midlife', 'over 40', 'older heroine', 'second act'] },
      { v: 'Sapphic', tag: ['rep:sapphic'], syn: ['sapphic', 'lesbian', 'wlw', 'ff romance', 'f/f'] },
      { v: 'MM', tag: ['rep:mlm'], syn: ['mm', 'm/m', 'mm romance', 'gay', 'gay romance', 'mlm'] },
      { v: 'Bisexual', tag: ['rep:bi'], syn: ['bisexual', 'bi'] },
      { v: 'Trans', tag: ['rep:trans'], syn: ['trans', 'transgender'] },
      { v: 'Ace & Demi', tag: ['rep:ace', 'rep:demi'], syn: ['asexual', 'ace', 'demisexual', 'demi'] },
      { v: 'Polyamory', tag: ['rep:poly'], syn: ['polyamory', 'polyamorous', 'poly'] }
    ]},
    { key: 'series', label: 'Series', field: 'series', advanced: true, values: [
      { v: 'Standalone', special: 'standalone', syn: ['standalone', 'stand alone', 'standalones', 'no series'] },
      { v: 'Book 1 of a Series', special: 'book1', syn: ['first in series', 'book 1', 'book one', 'series starter', 'new series'] }
    ]},
    /* Nov 2, 2026: collectors search "deluxe", "special edition", "sprayed edges". Matches the edition label
       (custom.edition_label, e.g. "Deluxe Edition · Hardcover") or the title ("(Special Edition)"). */
    { key: 'edition', label: 'Edition', field: 'edition', advanced: true, values: [
      { v: 'Special & Deluxe Editions', special: 'edition', syn: ['deluxe', 'deluxe edition', 'deluxe editions', 'special edition', 'special editions', 'sprayed edges', 'sprayed edge', 'sprayed edge books', 'limited edition', 'collectors edition', "collector's edition", 'exclusive edition', 'signed special edition'] }
    ]},
    { key: 'authors', label: 'Authors', field: 'authors', advanced: true, values: [
      { v: 'Local Author (NJ)', tag: ['flag:local-author'], syn: ['local author', 'local authors', 'nj author', 'new jersey author'] },
      { v: 'Indie Author', tag: ['flag:indie-author'], syn: ['indie author', 'indie authors', 'self published'] },
      /* identity tags: only authors who publicly identify (see docs/rosebound_author_review.xlsx) */
      { v: 'Black Author', tag: ['flag:black-author'], syn: ['black author', 'black authors', 'black women authors'] },
      { v: 'Latine Author', tag: ['flag:latine-author'], syn: ['latine author', 'latina author', 'latino author', 'latinx author', 'hispanic author'] },
      { v: 'Asian & AAPI Author', tag: ['flag:aapi-author'], syn: ['asian author', 'aapi author', 'asian american author', 'south asian author', 'desi author'] }
      /* flag:lgbtq-author stays on products but is not a filter (Jordan, Oct 20) - hard to measure; queer-author searches go to LGBTQ+ Romance */
    ]},
    /* Leave out: removes books with this content. Only plot-level notes readers flag consistently.
       While any is on, books we have not checked yet (no spice rating) are hidden too. */
    { key: 'leaveout', label: 'Leave out', field: 'leave_out', advanced: true, exclude: true, values: [
      { v: 'Love triangle', tag: ['trope:love-triangle'], syn: [] },
      { v: 'Cheating', tag: ['trope:cheating', 'cw:cheating', 'cw:infidelity'], syn: [] },
      { v: 'Sad ending', tag: ['flag:no-happy-ending'], syn: [] },
      { v: 'Dubious consent', tag: ['cw:dub-con', 'cw:consensual-non-con', 'cw:non-con'], syn: [] },
      { v: 'Sexual assault', tag: ['cw:sexual-assault', 'cw:child-sexual-abuse'], syn: [] }
    ]},
    { key: 'avail', label: 'Availability', field: 'availability', values: [
      { v: 'In stock', special: 'instock', syn: [] },
      { v: 'Out of stock', special: 'oos', syn: [] }
    ]}
  ];

  /* ---------- Merch filters (Gifts & Bookish Goods). Used when the section's data-mode is "merch".
     type = Shopify product types; tag = product tags from the Oct 4 merch tagging pass;
     price = [from, to) in dollars. ---------- */
  var GM = [
    { key: 'type', label: 'Type', field: 'type', values: [
      { v: 'Bookmarks', type: ['Bookmark'] },
      { v: 'Stickers & Magnets', type: ['Sticker', 'Sticker Book', 'Magnet'] },
      /* Nov 3, 2026: renamed from 'Kindle Accessories'; added Kindle Kit + Reading Light (Jordan) */
      { v: 'Kindle & Reading Accessories', type: ['Kindle Grip', 'Kindle Case', 'Kindle Sleeve', 'Kindle Charm', 'Kindle Kit', 'Reading Light'] },
      { v: 'Jewelry', type: ['Jewelry'] },
      { v: 'Keychains & Pins', type: ['Keychain', 'Pin', 'Bag Charm'] },
      { v: 'Totes & Pouches', type: ['Tote Bag', 'Zipper Pouch', 'Pencil Case', 'Wallet'] },
      { v: 'Apparel & Hats', type: ['Apparel', 'Hat', 'Socks'] },
      { v: 'Hair Accessories', type: ['Hair Clip', 'Scrunchie'] },
      { v: 'Candles & Home', type: ['Candle', 'Wax Melts', 'Simmer Spices'] },
      { v: 'Tea & Pampering', type: ['Tea', 'Bath Soak', 'Lip Balm', 'Lotion Set'] },
      { v: 'Mugs & Drinkware', type: ['Mug', 'Travel Mug', 'Wine Glass', 'Coffee Sleeve'] },
      { v: 'Journals & Stationery', type: ['Journal', 'Reading Journal', 'Notes', 'Planner', 'Calendar', 'Highlighters', 'Erasers', 'Pens', 'Reading Kit'] },
      { v: 'Book Covers', type: ['Book Cover'] },
      { v: 'Crafts, Puzzles & Games', type: ['Craft', 'Embroidery Kit', 'Puzzle', 'Game', 'Coloring Book', 'Activity Book'] },
      { v: 'Greeting Cards', type: ['Greeting Card'] },
      { v: 'Blind Date & Gift Books', type: ['Book'] },
      { v: 'For Kids', type: ['Toys', "Kid's Kit", 'Crayons'], tag: ['genre:childrens'] },
      { v: 'Gift Cards', type: ['Gift Card'] }
    ]},
    { key: 'price', label: 'Price', field: 'price', values: [
      { v: 'Under $10', price: [0, 10] },
      { v: '$10 – $25', price: [10, 25] },
      { v: '$25 – $50', price: [25, 50] },
      { v: '$50 & up', price: [50, 100000] }
    ]},
    { key: 'fandom', label: 'Fandom', field: 'fandom', values: [
      { v: 'Fourth Wing', tag: ['series:empyrean'] },
      { v: 'ACOTAR', tag: ['series:acotar'] },
      { v: 'Throne of Glass', tag: ['series:throne-of-glass'] },
      { v: 'Shield of Sparrows', tag: ['series:shield-of-sparrows'] },
      { v: 'Dream Harbor', tag: ['series:dream-harbor'] }
    ]},
    { key: 'reads', label: 'For Fans Of', field: 'reads', values: [
      { v: 'Romantasy & Dragons', tag: ['genre:romantasy', 'trope:dragons', 'trope:fae'] },
      { v: 'Spicy Reads (18+)', tag: ['theme:spicy', 'flag:mature'] },
      { v: 'Romance Tropes', tag: ['trope:enemies-to-lovers', 'trope:slow-burn', 'trope:only-one-bed', 'trope:second-chance', 'trope:mutual-pining', 'trope:rom-com', 'trope:star-crossed'] },
      { v: 'Sports & Hockey Romance', tag: ['genre:sports-romance', 'trope:hockey'] },
      { v: 'Dark Academia', tag: ['trope:dark-academia'] },
      { v: 'Witchy & Magic', tag: ['theme:magic', 'trope:witches'] },
      { v: 'Fairytales', tag: ['trope:fairytale'] },
      { v: 'Pride', tag: ['theme:pride', 'genre:lgbtq-romance'] },
      { v: 'Cowboy Romance', tag: ['genre:cowboy-romance'] }
    ]},
    { key: 'vibe', label: 'Vibe', field: 'vibe', values: [
      { v: 'Book Lover', tag: ['theme:book-lover'] },
      { v: 'TBR & Book Club', tag: ['theme:tbr', 'theme:book-club'] },
      { v: 'Funny', tag: ['theme:funny'] },
      { v: 'Floral', tag: ['style:floral'] },
      { v: 'Coquette & Bows', tag: ['style:coquette'] },
      { v: 'Dark & Moody', tag: ['style:dark'] },
      { v: 'Whimsical', tag: ['style:whimsical'] },
      { v: 'Vintage', tag: ['style:vintage', 'style:retro'] },
      { v: 'Coffee & Wine', tag: ['theme:coffee', 'theme:wine'] },
      { v: 'Introvert', tag: ['theme:introvert'] },
      { v: 'Rosebound Originals', tag: ['flag:rosebound-branded', 'theme:rosebound'] }
    ]},
    { key: 'season', label: 'Season', field: 'season', values: [
      { v: 'Fall', tag: ['holiday:fall'] },
      { v: 'Halloween', tag: ['holiday:halloween'] },
      { v: 'Christmas & Holidays', tag: ['holiday:christmas', 'holiday:hanukkah'] },
      { v: "Valentine's", tag: ['holiday:valentines'] },
      { v: 'Summer', tag: ['holiday:summer'] }
    ]},
    { key: 'occasion', label: 'Card Occasion', field: 'occasion', values: [
      { v: 'Birthday', tag: ['occasion:birthday'] },
      { v: 'Just Because', tag: ['occasion:just-because', 'occasion:friendship'] },
      { v: 'Love', tag: ['occasion:love'] },
      { v: 'Wedding & Congrats', tag: ['occasion:wedding', 'occasion:congrats'] },
      { v: 'Baby', tag: ['occasion:baby'] },
      { v: 'Thank You & Teacher', tag: ['occasion:thank-you', 'occasion:teacher'] }
    ]},
    { key: 'avail', label: 'Availability', field: 'availability', values: [
      { v: 'In stock', special: 'instock', syn: [] },
      { v: 'Out of stock', special: 'oos', syn: [] }
    ]}
  ];

  function spiceNum(s) { var m = (s || '').match(/^\s*(\d)/); return m ? m[1] : null; }

  /* A book counts as "checked" once it has a spice rating (from the content lookup). */
  function checked(book) { return spiceNum(book.s) !== null || book.tg.some(function (t) { return t.indexOf('spice:') === 0; }); }

  /* Special / deluxe / limited / collector's editions, from the edition label (book.f) or the title (book.t). */
  var EDITION_RE = /\bdeluxe\b|\b(special|limited|collector'?s|exclusive|anniversary)\s+(\w+\s+)?edition\b/i;

  function matches(book, val) {
    var i;
    if (val.special === 'standalone') return !book.tg.some(function (t) { return t.indexOf('series:') === 0; });
    if (val.special === 'book1') return book.tg.indexOf('series-num:1') > -1;
    if (val.special === 'instock') return !!book.a;
    if (val.special === 'oos') return !book.a;
    if (val.special === 'darkfantasy') return book.g === 'Romantasy' && book.tg.indexOf('mood:dark') > -1;
    if (val.special === 'edition') return EDITION_RE.test(book.f || '') || EDITION_RE.test(book.t || '');
    if (val.type && val.type.indexOf(book.y) > -1) return true;
    if (val.price) { var pr = parseFloat(String(book.p || '').replace(/[^0-9.]/g, '')); if (!isNaN(pr) && pr >= val.price[0] && pr < val.price[1]) return true; }
    if (val.genre && val.genre.indexOf(book.g) > -1) return true;
    if (val.spice && val.spice.indexOf(spiceNum(book.s)) > -1) return true;
    if (val.tr) for (i = 0; i < val.tr.length; i++) if ((book.tr || []).indexOf(val.tr[i]) > -1) return true;
    if (val.tag) for (i = 0; i < val.tag.length; i++) if (book.tg.indexOf(val.tag[i]) > -1) return true;
    return false;
  }

  function norm(s) {
    return (' ' + (s || '').toLowerCase().replace(/[’']/g, "'").replace(/[^a-z0-9'+\/ ]+/g, ' ').replace(/\s+/g, ' ').trim() + ' ');
  }

  /* Find filter values mentioned in a search. Longest phrases win; one value per group except spice. */
  function parseQuery(q) {
    var text = norm(q), hits = [], cands = [];
    G.forEach(function (g) {
      if (g.key === 'avail' || g.exclude) return;
      g.values.forEach(function (v) {
        var words = [v.v].concat(v.syn || []);
        words.forEach(function (w) { cands.push({ g: g, v: v, w: norm(w) }); });
      });
    });
    cands.sort(function (a, b) { return b.w.length - a.w.length; });
    var used = {};
    cands.forEach(function (c) {
      if (c.w.trim().length < 2) return;
      var idx = text.indexOf(c.w);
      if (idx < 0) return;
      if (used[c.g.key + '|' + c.v.v]) return;
      if (c.v.group === 'spicy' && c.w.trim() === 'spicy') {
        ['3 – Spicy', '4 – Very Spicy', '5 – Scorching'].forEach(function (sv) {
          var val = G[1].values.filter(function (x) { return x.v === sv; })[0];
          if (!used['spice|' + sv]) { used['spice|' + sv] = 1; hits.push({ group: G[1], value: val }); }
        });
      } else {
        used[c.g.key + '|' + c.v.v] = 1;
        hits.push({ group: c.g, value: c.v });
      }
      text = text.slice(0, idx) + ' ' + text.slice(idx + c.w.length - 1);
    });
    hits.rest = text.trim();
    return hits;
  }

  /* merch pages (section data-mode="merch") get the merch groups; everything else the book groups */
  var rbRoot = document.querySelector('[data-rbf-root]'), merch = !!(rbRoot && rbRoot.dataset.mode === 'merch');
  window.RB_FILTERS = { groups: merch ? GM : G, merch: merch, open: merch ? ['type', 'price'] : ['genre', 'spice'], matches: matches, checked: checked, parseQuery: parseQuery };
})();
